import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-451be6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-height":"100%"} }
const _hoisted_2 = { id: "boardContainer" }
const _hoisted_3 = { id: "HUDContainer" }
const _hoisted_4 = { id: "turnDisplay" }
const _hoisted_5 = {
  key: 0,
  ref: "turnDisplayTxt"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Player ")
const _hoisted_7 = { style: {"font-weight":"bolder"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("'s Turn ")
const _hoisted_9 = {
  key: 1,
  ref: "winDisplayTxt"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 🏆 Player ")
const _hoisted_11 = { style: {"font-weight":"bolder"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Won! ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"20px","margin":"0","color":"white !important","font-weight":"500"} }, " Done! (switch turn) ", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_PopTable = _resolveComponent("PopTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.getPlayerWon()===-1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getPlayer()), 1),
                _hoisted_8
              ], 512))
            : _createCommentVNode("", true),
          (_ctx.getPlayerWon()!==-1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getPlayerWon()), 1),
                _hoisted_12
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          id: "resetButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
        }, [
          _createVNode(_component_ion_icon, {
            name: "reload-circle-sharp",
            style: {"font-size":"32px"}
          })
        ])
      ]),
      _createVNode(_component_PopTable),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          id: "switchTurnBttn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSwitchClick && _ctx.onSwitchClick(...args)))
        }, _hoisted_14)
      ])
    ])
  ]))
}